import React from "react";
import "./Academics.css";
import { motion } from "framer-motion";

const Academics = () => {
  const academics = [
    { icon: "🎓", course: "Graduation (B.Tech)", institute: "Raghu Engineering College", board: "J.N.T.U. Kakinada", year: "2020" },
    { icon: "📘", course: "PU College", institute: "Narayana Jr. College", board: "Board of Intermediate", year: "2016" },
    { icon: "🏫", course: "Schooling", institute: "Narayana E-Techno School", board: "Secondary School Certificate", year: "2014" },
  ];

  // Variants
  const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.3 } } };
  const cardVariants = { hidden: { opacity: 0, y: 50 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } } };
  const paragraphVariants = { hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } } };
  const imageVariants = { hidden: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } } };

  return (
    <section id="academics" className="education section-padding">

      {/* Header */}
      <motion.div
        className="section-header text-center"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1 }}
      >
        <h2>My Academics</h2>
      </motion.div>

      {/* Education Cards */}
      <motion.div
        className="cards-container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
      >
        {academics.map((item, index) => (
          <motion.div key={index} className="academic-card" variants={cardVariants}>
            <div className="card-icon">{item.icon}</div>
            <h3 className="course">{item.course}</h3>
            <p><strong>Institute:</strong> {item.institute}</p>
            <p><strong>University/Board:</strong> {item.board}</p>
            <p><strong>Passed Out:</strong> {item.year}</p>
          </motion.div>
        ))}
      </motion.div>

      {/* College Life */}
      <motion.h3
        className="section-subtitle"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8 }}
      >
        What I have done in my academics?
      </motion.h3>

      <motion.div className="about-paragraphs" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={containerVariants}>
        <motion.p className="my-clg-para" variants={paragraphVariants}>
          Talking about my college life, I had enjoyed my college life to the
          fullest and had some of the best college days of my life. I was a
          student of one of the most reputed colleges of 'JNTUK' and, i.e. 'Raghu
          Engineering College'. I have completed my B.E. (MECH.) from there. The
          College is one of the renowned and best colleges of 'JNTUK'. Built in a
          larger area, it is a beautiful college with many courses in streams like
          MECH, CSE, ECE, EEE, CIVIL and so on with an outstanding academic
          record. When I took admission to this college, I was really afraid as
          all the people were new to me. But soon, I started enjoying my college
          life and made some fantastic friends. I loved everything about my
          college and participated in the events at my college. Even I joined the
          many societies of my college and participated in many competitions that
          occurred in different colleges.
        </motion.p>

        <motion.p className="my-clg-para" variants={paragraphVariants}>
          One of the best things about college life is that you get a new
          experience every day. In my college life, along with studying, I and my
          friends enjoyed a lot of other things. We traveled to lots of places,
          had new experiences, and learned many new things. Our college's canteen
          was a remarkable place in my college life as whenever we got time, we
          used to chill in the canteen.
        </motion.p>

        <motion.p className="my-clg-para" variants={paragraphVariants}>
          Another thing I loved about my college life is Annual Fests. Every year,
          my college organizes an annual fest that lasts for 2-3 days. In this
          annual fest, various competitions happen, and students from various
          colleges come to be a part of this annual fest and enjoy a lot in this
          fest. Our HOD <span className="highlight">" Mr. N. Surya Chandra Chaitanya "</span> told us,
          These fests allow students to socialize with new people and showcase
          their talent to everyone which builds their confidence and helps them in
          their future. So, we have participated in my college's annual fest for
          all four years and I'm the coordinator for two times and got the
          best exposure, experience of my life through this fest. I had the best
          time of my life in college, the memories will always make me happy.
        </motion.p>
      </motion.div>

      {/* Projects Section */}
      <motion.h3
        className="section-subtitle projects-title"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8 }}
      >
        Projects done by me:
      </motion.h3>

      <motion.p className="my-clg-para" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={paragraphVariants}>
        <span>Aha! This is my favorite section.</span>
        <br />
        I really love to create new things and sometimes i feel my projects are
        my own kids, whenever I get a chance I used to keep my entire presents
        and efforts in it and build the products. I Specially Thanks to my guide{" "}
        <span className="highlight">" Mr. N. Surya Chandra Chaitanya "</span> who is our Head of the
        Department helped me a lot to build projects and mainly work on new
        technologies like EV vehicles, Solar Energy, Fuel cells and Robotics.
      </motion.p>

      {/* Project Images */}
      <motion.div className="project-gallery" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={containerVariants}>
        <motion.img src="/images/Edu 1.jpeg" alt="Project 1" className="pro_Img" variants={imageVariants}/>
        <motion.img src="/images/Edu 2.jpg" alt="Project 2" className="pro_Img" variants={imageVariants}/>
        <motion.img src="/images/Edu 4.jpg" alt="Project 3" className="pro_Img" variants={imageVariants}/>
      </motion.div>

      {/* Major Project */}
      <motion.h3 className="section-subtitle" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={paragraphVariants}>
        My Major Project:
      </motion.h3>

      <motion.p className="my-clg-para" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={paragraphVariants}>
        As we guys have to submit a major project in final year which is the
        only project shows our talent & knowledge gained in the entire
        academics, so I decided to build something New & Big which shows what I am! My guide{" "}
        <span className="highlight">" Dr. Panchanand Jha "</span> helped me a lot in robotics, AI, and GAIT analysis.
      </motion.p>

      <motion.h3 className="major-title text-center" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={paragraphVariants}>
        Design, Fabrication & GAIT Analysis of Humanoid Robot
      </motion.h3>

      <motion.p className="my-clg-para" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={paragraphVariants}>
        After deciding the topic, I studied many research papers. Using CATIA-V5, I designed the robot, then fabricated it with a Prusa 3D printer. Coding and assembly were done using ESP8266 WIFI module. GAIT analysis was done using MATLAB, and finally, I enjoyed <span className="success-text">"The Happiness of SUCCESS"</span>. Special thanks to <span className="highlight">" Dr. Panchanand Jha "</span> for guiding me.
      </motion.p>

      <motion.div className="project-image" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={imageVariants}>
        <img src="/images/major project.PNG" alt="Major Project" className="my_robot"/>
      </motion.div>

    </section>
  );
};

export default Academics;
